<template>
  <div>
    <span :class="{'extra-question-label': isExtraQuestion}">{{ question }}</span>&nbsp;
    <b-input value="textEntered" v-model="textEntered"
             :disabled="isDisabled" :tabIndex="tab"
             :placeholder="placeholder"
             @input="questionAnswered()"
             :class="[{mandatory : isMandatory}, 'question-control', {dropdowncontrol: isDropdownControlled},
             'form-label',{'new-line': isNewLine}]"
             :maxlength="maxlength">
    </b-input>
    <span :class="[{'extra-question-label': isExtraQuestion}, {'closing-tag-none':isNotDisplayed}]">{{closingTag}}</span>
  </div>
</template>
<script>
export default {
  name: 'FreetextQuestion',
  props: {
    question: String,
    closingTag: String,
    placeholder: String,
    isDisabled: Boolean,
    isMandatory: Boolean,
    isDropdownControlled: Boolean,
    isExtraQuestion: Boolean,
    isNotDisplayed: Boolean,
    isNewLine: Boolean,
    maxlength: String,
    existingValue: { type: String, default: '' },
    tab: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      textEntered: this.existingValue,
    };
  },
  watch: {
    isDisabled(n) {
      if (n) {
        this.textEntered = '';
      }
    },
  },
  methods: {
    questionAnswered() {
      this.$emit('question-answered', this.textEntered);
    },
  },
};
</script>

<style lang="scss">
.app .desktop-view {
        div.new-line {
          display:block;
          margin-top:2%;
          margin-left:0;
          input {
            width:95%;
            padding: 0;
          }
          .help.counter {
            float:left;
          }
        }
}

small.is-invisible {
    visibility: hidden;
}
</style>
